/*
 * @Author: Roman
 * @Date: 2023-01-11 14:41:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-01-07 11:20:07
 * @FilePath: \qpmn-site\src\app\modules\common\common.module.ts
 * @Description: 
 */
/**
 * @description common模块内容注册
 */

import angular from 'angular';

/************************************** Module ***********************************************/

/************************************** Config ***********************************************/

import { KeyRestConfig } from './rest/service/key-rest.service.config';

import { StateFlowRestConfig } from './rest/stateFlow/state-flow-rest-service.config';


/************************************** Service ***********************************************/

import { BaseGrammar } from "./base-grammar.service";

import { EventBus } from './tool/event/event-bus';

import { RestProvider } from './rest/service/rest.provider';

import { UrlBuilder } from './rest/service/url-builder.service';

import { KeyRestService } from './rest/service/key-rest.service';

import { StateFlowRestService } from './rest/stateFlow/state-flow-rest.service';



/************************************** 内容注册 ***********************************************/

let commonModuleName = "qpmn-common";

let CommonModule = angular.module(commonModuleName, [])

CommonModule.provider({
    $rest: RestProvider
});

CommonModule.service({
    baseGrammar: BaseGrammar,
    eventBus: EventBus,
    urlBuilder: UrlBuilder,
    keyRestService: KeyRestService,
    stateFlowRestService: StateFlowRestService
})

CommonModule.config(["$restProvider", function ($restProvider) {
    $restProvider.configs([KeyRestConfig.getKey, StateFlowRestConfig].concat())
}])

export { CommonModule, commonModuleName }